module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/Direction/images/direction-icon-B.85994fc8.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Direction/images/direction-icon-B.png
// module id = 2513
// module chunks = 11